import { render, staticRenderFns } from "./ReviewValidation.vue?vue&type=template&id=fdf00c5c"
import script from "./ReviewValidation.vue?vue&type=script&lang=js"
export * from "./ReviewValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports